import React from 'react';
import { makeStyles, Checkbox, FormControlLabel } from '@material-ui/core';
import clsx from 'clsx';

// @ts-ignore
const useStyles = makeStyles((theme) => ({
  rootCheckbox: {
    padding: 0,
    margin: '0 1.5px',
    width: '15px',
    height: '15px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& .MuiSvgIcon-root': {
      fill: theme.palette.primary.main,
    },
  },
  // @ts-ignore
  rootCheckboxGroup: ({ spaceBetween }) => ({
    marginLeft: '0',
    width: spaceBetween ? '100%' : 'auto',
    justifyContent: spaceBetween ? 'space-between' : 'unset',
  }),
}));

export const BaseCheckbox: React.FC<any> = (props) => {
  const classes = useStyles();

  return (
    <Checkbox
      className={classes.rootCheckbox}
      disableRipple
      inputProps={{ 'aria-label': 'decorative checkbox' }}
      {...props}
    />
  );
};

export const BaseCheckboxWithLabel: React.FC<any> = (props) => {
  const classes = useStyles(props);
  const { labelPlacement, label, className, ...otherProps } = props;
  const labelStyles =
    labelPlacement === 'start'
      ? { marginRight: '10px', display: 'flex' }
      : { marginLeft: '10px', display: 'flex' };

  return (
    <FormControlLabel
      className={clsx(classes.rootCheckboxGroup, className)}
      control={<BaseCheckbox />}
      label={<span style={labelStyles}>{label}</span>}
      labelPlacement={labelPlacement}
      {...otherProps}
    />
  );
};
